const JCB = {
  length: 5.7,
  frontWheelRadius: 0.44,
  frontTyreWidth: 0.31,
  rearWheelRadius: 0.7,
  rearTyreWidth: 0.43,
  frontAxleX: 1.05,
  rearAxleX: -1.05,
  frontHalfTrack: 0.88,
  /** Wider than the front, which also keeps the big rear tyres clear of the cab. */
  rearHalfTrack: 0.95
};
export {
  JCB
};
